import { Component, OnDestroy } from "@angular/core";

/**
 * Reusable component base should be used whenever a component needs to be reusable (cached) in routing
 */
@Component({
  template: '',
})
export abstract class ReusableComponent implements OnDestroy {
  constructor() { }

  /**
   * ngOnDestroy should be available for each reusable component in order to call it when the cached component is not needed anymore
   */
  ngOnDestroy(): void { }
}
